import { HttpRequestData, httpUtil } from '@esg/framework';
import { getEnv } from '@esg/shared';

interface GetOverviewTransactionRequest extends HttpRequestData {
    query: {
        startTime: string;
        endTime: string;
        branchId?: string;
        customerId?: string;

    };
}

export interface TransactionChannelMetric {
    type: string;
    totalSent: number;
    totalDelivered: number;
    totalFailed: number;
}

export interface TransactionCategoryMetric {
    category: string;
    totalSent: number;
    totalDelivered: number;
    totalFailed: number;
}

export interface TransactionActionMetric {
    action: string;
    totalSent: number;
    totalDelivered: number;
    totalFailed: number;
}

export interface OverviewTransactionMetric {
    type: string;
    totalSent: number;
    totalDelivered: number;
    totalFailed: number;
}

export interface GetOverviewTransactionResponseItem {
    totalSent: number;
    totalDelivered: number;
    totalFailed: number;
    metrics: TransactionChannelMetric[];
    categories: TransactionCategoryMetric[];
    actions: TransactionActionMetric[];
}

export const getOverviewTransaction = httpUtil.createHttpRequestMeta<
    GetOverviewTransactionRequest,
    GetOverviewTransactionResponseItem
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/external-transactions/overview',
    method: 'GET',
    authentication: 'bearer',
});